<div>
  <zaver-button-link
    *ngIf="showLink"
    style="
      display: flex;
      justify-content: center;
      margin-top: 24px;
      margin-bottom: 16px;
    "
    [color]="Color.Black"
    (click)="activateModal()"
    [text]="'Details anzeigen'"
  ></zaver-button-link>

  <p class="disclaimer-paragraph">
    Indem ich fortfahre, stimme ich,
    <a
      class="disclaimer-link"
      target="_blank"
      [href]="'https://zaver.com/terms-de/nutzungsbedingungen'"
      >Zaver´s Nutzungsbedingungen</a
    >,
    <a
      class="disclaimer-link"
      target="_blank"
      [href]="'https://zaver.com/terms-de/datenschutz'"
      >Datenschutz
    </a>
    und
    <a
      class="disclaimer-link"
      target="_blank"
      [href]="'https://zaver.com/de/cookies'"
      >Cookie-Richtlinie </a
    >&nbsp;zu.&nbsp;<a
      class="disclaimer-link"
      target="_blank"
      [href]="'https://zaver.com/terms-de/impressum'"
      >Impressum</a
    >.
    <br />
    <a
      *ngIf="tokenizedOnboardingText && tokenizedOnboardingUrl"
      class="disclaimer-link"
      target="_blank"
      [href]="tokenizedOnboardingUrl"
      >{{ tokenizedOnboardingText }}</a
    >
  </p>
</div>

<zaver-checkout-modal
  [buttonText]="'Schließen'"
  *ngIf="selectorItems && modalActive"
  [logo]="'assets/img/Zaver_Logotype_Circle_Coal_DE.svg'"
  (onClose)="deactivateModal()"
>
  <app-selector *ngIf="!!selectorItems" [selectorItems]="selectorItems">
    <zaver-button-link [text]="'Allgemeine Zahlungsbedingungen'">
    </zaver-button-link>
  </app-selector>
</zaver-checkout-modal>
